import { UploadedImage, ImageForUpload } from "./classes/Image";
import ImageApi from "./api/imageApi";

export class ImageService {
  static createImageFromData(data) {
    if (data.id) {
      return new UploadedImage(data);
    } else {
      return new ImageForUpload(data);
    }
  }

  static updateOrUploadImage(image) {
    return new Promise((resolve, reject) => {
      if (image.id) {
        this.updateImage(image).then(resolve).catch(reject);
      } else {
        this.uploadImage(image).then(resolve).catch(reject);
      }
    });
  }

  static prepareImageForUpload(image) {
    const formData = new FormData();
    if (image.id) {
      formData.append("id", image.id);
    }

    formData.append("crop_image", image.crop_image, image.crop_image.name || "image.jpg");
    formData.append("original_image", image.original_image, image.original_image.name);
    formData.append("crop_params", new Blob([JSON.stringify(image.crop_data)], { type: "application/json" }));
    formData.append("ordinal", image.ordinal);
    formData.append("is_custom_assortment", false);

    return formData;
  }

  static uploadImage(image) {
    return ImageApi.uploadImage(this.prepareImageForUpload(image));
  }

  static updateImage(image) {
    const formData = new FormData();

    formData.append("image", image.image, image.image.name || "image.jpg");
    formData.append("crop_params", new Blob([JSON.stringify(image.crop_data)], { type: "application/json" }));
    return ImageApi.updateImage(formData, image.id);
  }
}
